import { Dashboard } from "./Dtos";
import { signalRService } from "./SignalRService";

class DashboardService {
  private onDashboardUpdate: ((data: Dashboard) => void) | null = null;
  private onConnectionStateChange: ((state: string) => void) | null = null;

  constructor() {
    this.setupEventHandlers();
  }

  private setupEventHandlers() {
    const { connection } = signalRService;

    // Dashboard data update handler
    connection.on("dashboarddataupdated", (data: Dashboard) => {
   
      if (this.onDashboardUpdate) {
        this.onDashboardUpdate(data);
      }
    });

    // Connection state change handlers
    connection.onreconnecting(() => {
      if (this.onConnectionStateChange) {
        this.onConnectionStateChange("Reconnecting");
      }
    });

    connection.onreconnected(() => {
      if (this.onConnectionStateChange) {
        this.onConnectionStateChange("Connected");
      }
    });

    connection.onclose(() => {
      if (this.onConnectionStateChange) {
        this.onConnectionStateChange("Disconnected");
      }
    });
  }

  public connect(schoolId: string, userId: string): void {
    signalRService.connect().then(() => {
      signalRService.joinSchoolGroup(userId, schoolId);
    });
  }

  public disconnect(): void {
    signalRService.disconnect();
  }

  public onDashboardDataUpdate(callback: (data: Dashboard) => void): void {
    this.onDashboardUpdate = callback;
  }

  public onConnectionStateChanged(callback: (state: string) => void): void {
    this.onConnectionStateChange = callback;
  }

  public getConnectionState(): string {
    return signalRService.connection.state;
  }

  public isConnected(): boolean {
    return signalRService.connection.state === "Connected";
  }

  public async refreshDashboard(): Promise<void> {
    if (signalRService.connection.state !== "Connected") {
      return;
    }
  }
}

// Create a singleton instance
const dashboardService = new DashboardService();

export default dashboardService;
